export default "__VITE_ASSET__BDLnu8sg__"